import React, { useState, useEffect, useRef } from 'react'
import { useWallet } from 'use-wallet'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import share from 'assets/img/share.png'

const useExpired = (time) => {
  const [expired, setExpired] = useState(false)
  const timoutRef = useRef()
  useEffect(() => {
    timoutRef.current = setTimeout(() => {
      setExpired(true)
    }, time)
    return () => {
      clearTimeout(timoutRef.current)
    }
  }, [time])
  return expired
}

const Tooltip = ({ text, isShare }) => {
  const StyledWrapper = styled.span`
    padding: 5px;
    margin-top: 8px;
    width: 10px;
    cursor: pointer;
  `

  const [model, setModel] = useState({
    expiredAt: new Date().getTime() + 5000,
  })

  const expired = useExpired(model.expiredAt - new Date().getTime())

  const StyledText = styled.span`
    font-size: 15px;
    color: ${(props) => props.theme.color.grey[300]};
  `

  useEffect(() => {
    ReactTooltip.rebuild()
  })

  const [copied, setCopied] = useState('')
  const { ethereum, account } = useWallet()

  return (
    <>
      <StyledWrapper data-tip={text} data-for={isShare ? 'share': null}>
        {isShare ? (
          <img
            src={share}
            alt="share"
            height="20"
            onClick={() =>
              navigator.clipboard
                .writeText(`${window.location.href}?r=${account}`)
                .then(setCopied('copied'))
            }
          />
        ) : (
          <svg
            id="Capa_1"
            enableBackground="new 0 0 450.823 450.823"
            height="16"
            viewBox="0 0 450.823 450.823"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m225.412 0c-124.29 0-225.412 101.122-225.412 225.412s101.122 225.412 225.412 225.412 225.412-101.122 225.412-225.412-101.122-225.412-225.412-225.412zm0 422.647c-108.763 0-197.235-88.474-197.235-197.235 0-108.763 88.473-197.235 197.235-197.235s197.235 88.473 197.235 197.235c0 108.761-88.473 197.235-197.235 197.235z" />
            <path d="m289.663 118.895c8.253 8.253 8.253 21.633 0 29.886s-21.633 8.253-29.886 0-8.253-21.633 0-29.886 21.634-8.252 29.886 0" />
            <path d="m198.363 334.705c-.619-1.032-1.857-3.756-.151-6.92l68.515-127.248c5.09-9.466 4.43-20.816-1.72-29.621-6.136-8.805-16.647-13.332-27.213-11.818l-70.73 10.098 3.99 27.901 70.854-9.906-68.515 127.234c-5.916 11.006-5.627 23.994.784 34.725s17.693 17.142 30.199 17.142h77.389v-28.176h-77.389c-3.591.001-5.407-2.393-6.013-3.411z" />
          </svg>
        )}
      </StyledWrapper>
      {expired ? null : <StyledText>{copied}</StyledText>}
      <ReactTooltip html={true} id={isShare ? 'share' : null}/>
    </>
  )
}
export default Tooltip
